<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Left Col -->
    <div class="nav align-items-center d-xl-none">
      <b-link
        class="nav-link"
        @click="toggleVerticalMenuActive"
      >
        <feather-icon
          icon="MenuIcon"
          size="21"
        />
      </b-link>
    </div>
    <div class="nav flex-grow-1 align-items-center">
      <search-bar />
    </div>
    <div class="nav align-items-center ml-auto ">
  
    </div>
    <div class="nav align-items-center mr-2">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex justify-content-end align-items-center dropdown-user-link"
        class="dropdown-user"
        style="min-width: 150px;"
      >
        <template #button-content>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="$store.getters['oauth/getActiveUser'].avatar"
            class="badge-minimal"
            badge-variant="success"
          />
          <div class="d-sm-flex d-none user-nav align-items-start ml-2">
            <p class="user-name font-weight-bolder mb-0">
              {{ $store.getters['oauth/getActiveUser'].name }}
            </p>
          </div>
        </template>

        <b-dropdown-item v-if="isAdminOrApprover" link-class="d-flex align-items-center" @click="$store.commit('app/CHANGE_DISPLAY')">
          <feather-icon
          size="16"
          icon="UserIcon"
          class="mr-50"
          />
          <span>Admin</span>
        </b-dropdown-item>
        
        <b-dropdown-item link-class="d-flex align-items-center" to="/product-bookmark">
          <feather-icon
            size="16"
            icon="BookmarkIcon"
            class="mr-50"
          />
          <span>Bookmark</span>
        </b-dropdown-item>

        <b-dropdown-divider v-if="isAdminOrApprover" />
          
        <b-dropdown-item link-class="d-flex align-items-center">
          <div v-tracker="'button:logout'" @click="logout">
            <feather-icon
              size="16"
              icon="MessageSquareIcon"
              class="mr-50"
            />
            <span>Logout</span>
          </div>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </div>

    
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, BButton
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Ripple from 'vue-ripple-directive'
import SearchBar from '@core/layouts/components/app-navbar/components/SearchBar'
import { methods } from 'vue-echarts'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BButton,
    SearchBar,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  directives: {
    Ripple,
  },
  computed: {
    isAdminOrApprover() {
      let roles = this.$store.getters['oauth/getActiveUser'].role
      if (roles.includes('approver') || roles.includes('admin')) {
        return true
      }
      return false
    }
  },
  methods: {
    logout() {
      this.$store.commit('oauth/clearToken');
      
      localStorage.removeItem('token');
      localStorage.removeItem('coin');
      localStorage.removeItem('role');
      
      this.$http.defaults.headers.common['Authorization'] = '';
      
      document.cookie.split(";").forEach(cookie => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      });
      
      this.$router.push({ name: 'login' });
    },
  },
}
</script>
